import React from 'react'
import Box from '@mui/material/Box'

const Gallery = ({ options }) => {
    return (
        <Box>Gallery Module</Box>
    )
}

export default Gallery
